const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Note {
  createdAt: string;
  userId: string;
  noteType: string;
  note: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.createdAt = data.createdAt;
    this.userId = data.userId;
    this.noteType = data.noteType;
    this.note = data.note;
  }
}

export class Notes {
  notes: any[];
  createdAt: string;
  userId: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    if (data.notes && typeof (data.notes) === 'object') {
      this.notes = data.notes.map(n => {
        if (!n.userId) { n.userId = data.userId; }
        if (!n.createdAt) { n.createdAt = data.createdAt; }
        return new Note(n);
      });
    } else {
      this.notes = [];
    }
    this.createdAt = data.createdAt;
    this.userId = data.userId;
  }
}



// WEBPACK FOOTER //
// ./src/app/notes/note.ts